export enum TOGGLE_TYPE {
    CHECKBOX = 'checkbox',
    SWITCH = 'switch'
}

export enum INFO_POPUP_TRIGGER {
    ICON = 'icon',
    TEXT = 'text'
}
